export default __webpack_public_path__ + "570e90239c34a1f7ed5c33ed577768af.svg";